module.exports = __webpack_public_path__ + "img/tooltip.8a20f55b.svg";